/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryStockItemsDto as DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-stock-items-dto';

export interface GetInventoryStockItems$Params {
  inventoryId: string;
  searchTerm?: string;
}

export function getInventoryStockItems(http: HttpClient, rootUrl: string, params: GetInventoryStockItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto>> {
  const rb = new RequestBuilder(rootUrl, getInventoryStockItems.PATH, 'get');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto>;
    })
  );
}

getInventoryStockItems.PATH = '/api/inventories/{inventoryId}/stock';
